import type {
  RyftPaymentUpdatePathParametersType,
  RyftPaymentUpdateRequestType,
  RyftPaymentUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";

export const useRyftManagementPaymentUpdate = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: ({
      paymentSessionId,
      data,
    }: RyftPaymentUpdatePathParametersType & {
      data: RyftPaymentUpdateRequestType;
    }) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `ryft-management/payment-sessions/${paymentSessionId}`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse<RyftPaymentUpdateResponseType>(response).data,
      ),
  });
};
